var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid two"},[_c('profile-form',{attrs:{"profile":_vm.currentUser}}),_c('update-password-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }